/**
 * Sync Monitoring API Client
 * API client for the sync status and the retry of a failed sync (the controls of a source live in the jobs screen)
 */

import { apiService } from '@/platform/api/api.service'

import type { SyncStatus } from '../types'

export const syncApi = {
  /**
   * Get comprehensive sync status for all data sources
   */
  getStatus: async (): Promise<SyncStatus> => {
    const response = await apiService.get<SyncStatus>('/api/imports/sync/status')
    return response.data
  },

  /**
   * Retry a failed sync operation
   */
  retrySync: async (logId: string): Promise<{ jobId: string; status: string; message: string }> => {
    const response = await apiService.post<{ jobId: string; status: string; message: string }>(
      `/api/admin/sync/history/${logId}/retry`,
    )
    return response.data
  },
}
